import EntitiesList from 'components/entities/EntitiesList';
import React from "react";
import { connect } from 'react-redux'
import { Menu } from "semantic-ui-react";
import { Form } from "semantic-ui-react";
import { Icon } from "semantic-ui-react";
import { Button } from "semantic-ui-react";
import { Card } from "semantic-ui-react";
import { createEntityWithDefaults } from "../../../actions/entities";
import { getDocumentsForDossier } from "../../../selectors/documents";
import NewEntityModal from "../../entities/NewEntityModal";
import DossierAttachmentForm from "../dossierFollowUp/DossierAttachmentForm";
import DocumentsListActions from "./DocumentsListActions";
import DocumentsListItem from "./DocumentsListItem";
import UploadDocumentForm from "./UploadDocumentForm";

const mapStateToProps = (state, ownProps) => {
  return {
    entities: getDocumentsForDossier(state, {dossierId: ownProps.dossierId}),
    entityName: 'document',
    item: DocumentsListItem,
    listComponent: Card.Group,
    form: UploadDocumentForm,
    loading: state.meta?.document?.loading,
    error: state.meta?.document?.error,
    addButton: AddButton
  };
}

const AddButton = (props) => {return(
  <Button onClick={props.onClick}>
    <Icon name='upload'/>
    {I18n.t(`components.dossier.documents.upload`)}
  </Button>
)}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    extraActions: () => {
      return <DocumentsListActions dossierId={ownProps.dossierId}/>
    },
    createEntityWithDefaults: () => {
      return dispatch(createEntityWithDefaults('document', {dossierId: ownProps.dossierId}))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EntitiesList)
